import { Injectable } from "@angular/core";
import {
  CanActivate,
  CanLoad,
  Route,
  UrlSegment,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate, CanLoad {
  constructor(private router: Router, private auth: AuthService) {}

  private handleRedirect(redirectUrl: string): boolean {
    this.router.navigate(["/login"], {
      queryParams: { returnUrl: redirectUrl },
    });
    return false;
  }

  private isUserLoggedIn(redirectUrl: string): boolean {
    if (!this.auth.isLoggedIn()) {
      return this.handleRedirect(redirectUrl);
    }
    return true;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.isUserLoggedIn(state.url);
  }

  canLoad(route: Route, segments: UrlSegment[]): boolean {
    const path = "/" + segments.map((s) => s.path).join("/");
    return this.isUserLoggedIn(path);
  }
}
